import { useMutation, useQuery } from "@apollo/client";
import { ADD_INCIDENT_MUTATION, GET_INCIDENT_KPI, LIST_INCIDENTS } from "../graphQl/SupportAPI";
import { toSupportPagination } from "../../../constants/supportStatus";

// Les filtres vides ("") ne doivent pas être envoyés à l'API.
const orUndefined = (v) => v || undefined;

export const useIncidents = ({ page = 1, pageSize = 10, status, priority, entityType, assigneeId } = {}) => {
  const { data, loading, error, refetch } = useQuery(LIST_INCIDENTS, {
    variables: {
      paginationParams: toSupportPagination(page, pageSize),
      status: orUndefined(status),
      priority: orUndefined(priority),
      entityType: orUndefined(entityType),
      assigneeId: orUndefined(assigneeId),
    },
    fetchPolicy: "cache-and-network",
  });

  const result = data?.QR_LIST_INCIDENT?.data;

  return {
    incidents: result?.content || [],
    kpi: result?.kpi || null,
    totalElements: result?.totalElements || 0,
    loading,
    error,
    refetch,
  };
};

export const useIncidentKpi = () => {
  const { data, loading, error } = useQuery(GET_INCIDENT_KPI, {
    variables: { paginationParams: toSupportPagination(1, 3) },
    fetchPolicy: "cache-and-network",
  });

  const kpi = data?.QR_LIST_INCIDENT?.data?.kpi || null;
  const openTotal = kpi ? (kpi.openNb || 0) + (kpi.inProgressNB || 0) + (kpi.waitingOnCustomerNB || 0) : 0;

  return { kpi, openTotal, loading, error };
};

export const useCreateIncident = () => {
  const [createMutation, { loading }] = useMutation(ADD_INCIDENT_MUTATION, {
    refetchQueries: ["ListIncidents", "IncidentKpi"],
  });

  const createIncident = async ({ requestId, priority, assigneeId }) => {
    const res = await createMutation({
      variables: { incidentInput: { requestId, priority, assigneeId: orUndefined(assigneeId) } },
    });
    return res.data?.MT_ADD_INCIDENT?.data;
  };

  return { createIncident, loading };
};
